import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigCheckbox from './ConfigCheckbox.js'
import {USPS_SHIP} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'has_nonstandard_characteristics'
const VALID_SHIPPER_TYPES = [USPS_SHIP]

export default function HasNonstandardCharacteristics() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = HasNonstandardCharacteristics.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigCheckbox
      label="Has Nonstandard Characteristics"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      helpLink="https://support.ordoro.com/how-to-ship-usps-packages-with-nonstandard-characteristics/#nonstandard-characteristics"
      helpLinkHint="Learn more"
    />
  )
}

HasNonstandardCharacteristics.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
